"use client";
import React, { createContext, useContext } from 'react';

// The shape of the theme config (can be improved with types later)
export type ThemeConfig = any;

const ThemeContext = createContext<ThemeConfig | null>(null);

export function ThemeProvider({ config, children }: { config: ThemeConfig; children: React.ReactNode }) {
  return <ThemeContext.Provider value={config}>{children}</ThemeContext.Provider>;
}

export function useThemeConfig(): ThemeConfig {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useThemeConfig must be used within a ThemeProvider');
  return ctx;
} 